import { AddTipState, TipModalType } from './types'

export const AddTipModalInitialState: AddTipState = Object.freeze({
  tipPercentage: null,
  customTipAmount: null,
  visibleModalType: TipModalType.None,
  isSkipTipModal: null,
})
